import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateDirective, TranslateModule, TranslatePipe } from '@codeandweb/ngx-translate';

import { InputTextModule } from '@app/primeng-overrides/inputtext';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ProgressBarModule } from 'primeng/progressbar';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SidebarModule } from 'primeng/sidebar';
import { ToastModule } from 'primeng/toast';

import { NumberDisplayModule } from '@app/components/number-display';
import { NomenclaturePipe } from '@app/nomenclature/nomenclature.pipe';
import { OperationTypePipe } from '@app/texte/operations-section/operationType.pipe';
import { UtilisateurPipe } from '@app/utilisateur/utilisateur.pipe';
import { YesNoPipe } from '@global/yes-no-pipe';
import { DebounceDirective } from '@helpers/debounce.directive';
import { FormatSizePipe } from '@helpers/format-size.pipe';
import { GZInputNumberFormatterDirective } from '@helpers/gz-input-number-formatter.directive';
import { LazyLoadImgDirective } from '@helpers/lazy-load-img.directive';
import { MonthPipe } from '@helpers/month.pipe';
import { VarDirective } from '@helpers/ng-var.directive';
import { SwitchMultiCasePipe } from '@helpers/switch-multi-case.pipe';
import { ArticleCiblePipe } from '@app/texte/operations-section/articleCible.pipe';
import { PositionCiblePipe } from '@app/texte/operations-section/positionCible.pipe';

@NgModule({
	imports: [
		ButtonModule,
		CardModule,
		CheckboxModule,
		CommonModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		InputTextModule,
		MessageModule,
		MessagesModule,
		NumberDisplayModule,
		ProgressBarModule,
		ScrollTopModule,
		SidebarModule,
		ToastModule,
		TranslateDirective,
		TranslatePipe,
	],
	providers: [DatePipe],
	declarations: [
		DebounceDirective,
		FormatSizePipe,
		GZInputNumberFormatterDirective,
		LazyLoadImgDirective,
		MonthPipe,
		NomenclaturePipe,
		SwitchMultiCasePipe,
		UtilisateurPipe,
		VarDirective,
		YesNoPipe,
		OperationTypePipe,
		ArticleCiblePipe,
		PositionCiblePipe
	],
	exports: [
		ButtonModule,
		CardModule,
		CheckboxModule,
		CommonModule,
		ConfirmDialogModule,
		DebounceDirective,
		DynamicDialogModule,
		FormatSizePipe,
		GZInputNumberFormatterDirective,
		InputTextModule,
		LazyLoadImgDirective,
		MessageModule,
		MessagesModule,
		MonthPipe,
		NomenclaturePipe,
		NumberDisplayModule,
		ProgressBarModule,
		ScrollTopModule,
		SidebarModule,
		SwitchMultiCasePipe,
		ToastModule,
		TranslateDirective,
		TranslateModule,
		TranslatePipe,
		UtilisateurPipe,
		YesNoPipe,
		OperationTypePipe,
		ArticleCiblePipe,
		PositionCiblePipe
	]
})
export class GlobalModule { }
